var ERPGatewayTypes;
(function (ERPGatewayTypes) {
    ERPGatewayTypes["None"] = "None";
    ERPGatewayTypes["QuickBooksOnline"] = "QuickBooks Online";
    ERPGatewayTypes["QuickBooksDesktop"] = "QuickBooks Desktop";
    ERPGatewayTypes["NetSuite"] = "netsuite";
    ERPGatewayTypes["Intacct"] = "intacct";
})(ERPGatewayTypes || (ERPGatewayTypes = {}));
var ERPGatewayAvailableFeatures;
(function (ERPGatewayAvailableFeatures) {
    ERPGatewayAvailableFeatures["None"] = "None";
    ERPGatewayAvailableFeatures["classes"] = "Classes";
    ERPGatewayAvailableFeatures["corporate_card_account"] = "Corporate Card Account";
    ERPGatewayAvailableFeatures["corporate_cards_account"] = "corporate_cards_account";
    ERPGatewayAvailableFeatures["corporate_cards_vendor"] = "corporate_cards_vendor";
    ERPGatewayAvailableFeatures["currencies"] = "Currencies";
    ERPGatewayAvailableFeatures["customers"] = "Customers";
    ERPGatewayAvailableFeatures["department"] = "Department";
    ERPGatewayAvailableFeatures["departments"] = "Departments";
    ERPGatewayAvailableFeatures["expensesCategories"] = "Expenses Categories";
    ERPGatewayAvailableFeatures["expense_report_including_corporate_cards_enabled"] = "Expense Report Including Corporate Cards Enabled";
    ERPGatewayAvailableFeatures["location"] = "Location";
    ERPGatewayAvailableFeatures["locations"] = "Locations";
    ERPGatewayAvailableFeatures["projects"] = "Projects";
    ERPGatewayAvailableFeatures["subsidiaries"] = "Subsidiaries";
    ERPGatewayAvailableFeatures["users"] = "Users";
})(ERPGatewayAvailableFeatures || (ERPGatewayAvailableFeatures = {}));
const erpModalUrl = {
    [ERPGatewayTypes.NetSuite]: {
        prod: 'https://erp-gateway.api.emburse.com/?token=',
        test: 'https://erp-gateway.api-test.emburse.com/?token='
    },
    [ERPGatewayTypes.Intacct]: {
        prod: 'https://erp-gateway.api.emburse.com/intacct/?token=',
        test: 'https://erp-gateway.api-test.emburse.com/intacct/?token='
    }
};
export { ERPGatewayTypes, ERPGatewayAvailableFeatures, erpModalUrl };
